<template>
<div id="payment_groom">
    <div class="pay_process">
    <div class="pay_process_wrap">
        <!-- 상단 바-->
        <div class="progress-bar-wrap">
            <div class="progress-bar">
                <div class="bar">
                    <div class="_fill"></div>
                </div>
                <div class="point" v-for="(item, index) in left_menu_list" :key="'left_menu'+index" :class="item['active_class']">
                        <div class="bullet">
                        <img :src="item.img_src">
                    </div>
                    <label class="label">{{item.menu_name}}</label>
                </div>
            </div>
        </div>
        <!-- 상단 바-->
        <!-- 오른쪽화면 -->
        <div class="process_content">
            <div class="pay_content_wrap">
                <!-- 상품타입 -->
                <div class="pay_content_01 pay_content" v-if="step==1">
                    <div class="paytit mylist">
                        <div class="btn_mylist">
                            <div @click="use_my_alarm">내 상품 목록</div>
                        </div>
                    </div>
                    <ul>
                        <li v-for=" (item, index) in groom_prodcut_list" :key="'pay_content_01'+index" :class="item['active_class']" @click="set_groom_product(item, index)">
                            <div>{{item.goods_group_name}}</div>
                        </li>
                    </ul>

                </div><!-- 상품타입 -->

                <!-- 시간선택 -->
                <div class="pay_content_01 pay_content" v-if="step==2">
                    <div class="paytit">
                    </div>
                    <template v-if="view_goods_type === 'time'">
                        <ul>
                            <template v-for=" (item , index) in groom_prodcut_time_list" v-if="use_extention_flag == false">

                                <li v-if="(item.continue_goods_yn == 0 || item.continue_goods_yn == 2)" :key="'pay_content_02'+index" :class="item['active_class']" @click="set_groom_product_time(item, index)">
                                    <div>{{item.groom_goods_name}}</div> 
                                </li>
                            </template>
                            <template v-for=" (item , index) in groom_prodcut_time_list" v-if="use_extention_flag == true">

                                <li v-if="item.continue_goods_yn != 2" :key="'pay_content_02'+index" :class="item['active_class']" @click="set_groom_product_time(item, index)">
                                    <div>{{item.groom_goods_name}}</div> 
                                </li>

                            </template>
                        </ul>
                    </template>
                    <template v-else>
                        <!-- 누리누나디자인작업 -->
                        <div class="select_usingtime select_groom" >
                            <b>참여인원 :</b>
                            <span class="square">{{person_groom_person_cnt}}</span> <b>명</b>
                            <button class="symbol" @click="clickPerson('plus')">+</button>
                            <button class="symbol" @click="clickPerson('minus')" >-</button>

                            <br>
                            <br>
                            <b>시간선택 :</b>
                            <span class="square">{{person_groom_amount_time | time_filter}}</span>
                            <button @click="clickTime('30')" style="font-weight:400">+30분</button>
                            <button @click="clickTime('60')" style="font-weight:400">+1시간</button>
                            <button @click="clickTime('0')" style="font-weight:400">초기화</button>
                        </div>
                        <div class="select_usingtime total_pay_card">
                            <b>카드 :</b>
                            <span class="nosquare">{{card_amount}}</span> <b>원</b>
                        </div>
                    </template>
                </div><!-- 시간선택 -->

                <!-- 마일리지 -->
                <div class="pay_content_05 pay_content" v-if="step==3 && mileage_use_yn == 1">
                    <div class="paytit">
                        <div class="paytit-text"></div>
                    </div>
                    <ul class="hidden-scroll">
                        <template v-if="mileage_chk === false">
                            <li @click="set_mileage(false)" class="pay-content-on" >
                                <div>마일리지미사용</div>
                            </li>
                            <li @click="set_mileage(true)">
                                <div>마일리지사용</div>
                            </li>
                        </template>
                        <template v-else>
                            <li @click="set_mileage(false)" >
                                <div>마일리지미사용</div>
                            </li>
                            <li @click="set_mileage(true)" class="pay-content-on">
                                <div>마일리지사용</div>
                            </li>
                        </template>
                    </ul>
                    <template v-if="mileage_chk === true">
                        <div class="mg_box_wrap">
                            <div>
                                <span>적립금액 :</span>
                                <mileage @milage="milage_payment" />
                            </div>

                            <div>
                                <span>적용금액 :</span>
                                <span>{{use_mileage.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</span>
                            </div>
                            <ul>
                                <li @click="set_mileage_button(use_min_unit)">+ {{(use_min_unit).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</li>
                                <li @click="set_mileage_button(use_min_unit*2)">+ {{(use_min_unit*2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</li>
                                <li @click="set_mileage_button(use_min_unit*10)">+ {{(use_min_unit*10).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</li>
                                <li @click="set_mileage_button('all')">전체적용</li>
                                <li @click="set_mileage_button('cancel')">전체취소</li>
                            </ul>

                            <p>※ 최소사용단위 : {{use_min_unit}}원    ※ 최소사용금액 : {{use_min_amount}}원</p>
                        </div>
                    </template>
                </div><!-- 마일리지 -->

                <!-- 할인쿠폰 -->
                <div class="pay_content_06 pay_content" v-if="step==4 && sale_use_yn == 1">
                    <div class="paytit">
                        <div class="paytit-text">할인쿠폰</div>
                    </div>
                    <ul class="hidden-scroll">
                        <template v-if="discount_coupon === true">
                            <li @click="set_discount_coupon(false)" >
                                <div>할인쿠폰미사용</div>
                            </li>
                            <li @click="set_discount_coupon(true)" class="pay-content-on">
                                <div>할인쿠폰사용</div>
                            </li>
                        </template>
                        <template v-else>
                            <li @click="set_discount_coupon(false)" class="pay-content-on">
                                <div>할인쿠폰미사용</div>
                            </li>
                            <li @click="set_discount_coupon(true)" >
                                <div>할인쿠폰사용</div>
                            </li>
                        </template>
                    </ul>
                    <template v-if="discount_coupon === true">
                        <div class="cp_box_wrap">
                            <div class="cp_box">
                                <span>쿠폰코드 :</span>
                                <span>{{discount_coupon_code | coupon_filter}}</span>
                            </div>
                            <button @click="coupon_check()">적용</button>
                        </div>

                        <div class="cp_num_pad">
                            <div class="pad_btn">
                                <span @click="coupoun_input('1')">1</span>
                                <span @click="coupoun_input('2')">2</span>
                                <span @click="coupoun_input('3')">3</span>
                                <span @click="coupoun_input('4')">4</span>
                                <span @click="coupoun_input('5')">5</span>
                                <span @click="coupoun_input('6')">6</span>
                            </div>
                            <div class="pad_btn">
                                <span @click="coupoun_input('7')">7</span>
                                <span @click="coupoun_input('8')">8</span>
                                <span @click="coupoun_input('9')">9</span>
                                <span @click="coupoun_input('0')">0</span>
                                <span @click="coupoun_input('del')"><img src='../../assets/image/delete_gy.png'></span>
                            </div>

                        </div>
                    </template>
                </div><!-- 할인쿠폰 -->

                <!-- 결제 전 환불안내 -->
                <div class="pay_content_06 pay_content" v-if="step==5" style="overflow: hidden">
                  <template v-if="refund !='' && refund != undefined">
                    <p>환불규정</p>
                    <br>
                    <textarea readonly disabled style="width: 100%;height: 100%;border: none;">{{ refund }}</textarea>
                  </template>
                </div>
                <!-- 결제 완료 -->
                <div class="pay_content_09 pay_content" v-if="step==6">
                    <div class="finish_payment_wrap">
                        <div class="finish_head" v-if="last_price_card != 0">
                            <ul>
                                <li>
                                    <span class="pay_hd">결제금액</span>
                                    <span class="pay_ft">{{last_price_card}} 원</span>
                                </li>
                            </ul>
                        </div>

                        <div class="finish_body">
                            <p v-if="last_price_card != 0">결제가 완료되었습니다. </p>
                            <img src="../../assets/image/barcode_img.jpg">
                            <p>입력하신 휴대폰 번호로 <br><span>결제 정보</span>가 담긴 문자가 전송됩니다.
                            <!-- 250514 이용안내 팝업 추가 -->
                            <div v-if="usage_guide_useyn=='y'" class="guide_btn_wrap">
                                <div class="guide_btn" @click="open_guide()">이용안내</div>
                            </div>
                                
                            </p>
                        </div>

                        <div class="finish_footer pay_content_btn">
                            <div class="ok_btn" @click="step_finish(-1)">확인</div>
                        </div>
                    </div>
                </div><!-- 결제 완료 -->
            </div>
            <div class="pay_info">
                <div class="pay_info_wrap" v-if="step <= 5">
                    <div class="pay_wrap">
                        <div class="line_top"></div>
                        <ul>
                            <li>
                                <div class="pay_hd">상품종류</div>
                                <div class="pay_ft">{{ goods_group_name }}</div>
                            </li>
                            <li>
                                <div class="pay_hd">이용시간</div> 
                                <div class="pay_ft">{{groom_goods_name}}</div>
                            </li>
                            <li>
                                <div class="pay_hd">만료일수</div>
                                <div class="pay_ft">{{goods_end_time}}</div>
                            </li>
                            <li>
                                <div class="pay_hd">상품구분</div>
                                <div class="pay_ft">{{product_division}}</div>
                            </li>
                            <li v-if="mileage_use_yn == 1">
                                <div class="pay_hd" >마일리지</div>
                                <div class="pay_ft price">{{use_mileage.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}{{mileage_text}}</div>
                            </li>
                            <li v-if=" sale_use_yn == 1">
                                <div class="pay_hd">할인금액</div>
                                <div class="pay_ft price">{{discounted_price_card}}{{discount_text}}</div>
                            </li>
                            <li>
                                <div class="pay_hd">결제금액</div>
                                <div class="pay_ft price">{{last_price_card}} 원</div>
                            </li>
                        </ul>
                    </div>

                </div>
            </div>
            <div class="pay_content_btn" v-if="step == 1">
                    <div class="prev_btn" @click="step_controll_back()" v-if="step!=7 && step!=8 && step!=15">
                        이전
                    </div>
                    <div class="next_btn" @click="step_controll(1)" v-if="step!=7 && step!=8 && step!=15">
                        다음
                    </div>
            </div>
            <div class="pay_content_btn" v-if="step == 2">
                    <div class="prev_btn" @click="step_controll_back()" v-if="step!=7 && step!=8 && step!=15">
                        이전
                    </div>
                    <div class="next_btn" @click="step_controll(1)" v-if="step!=7 && step!=8 && step!=15">
                        다음
                    </div>
            </div>
            <div class="pay_content_btn" v-if="step==3 && mileage_use_yn == 1">
                    <div class="prev_btn" @click="step_controll_back()" v-if="step!=7 && step!=8 && step!=15">
                        이전
                    </div>
                    <div class="next_btn" @click="step_controll(1)" v-if="step!=7 && step!=8 && step!=15">
                        다음
                    </div>
            </div>
            <div class="pay_content_btn" v-if="step==4 && sale_use_yn == 1">
                    <div class="prev_btn" @click="step_controll_back()" v-if="step!=7 && step!=8 && step!=15">
                        이전
                    </div>
                    <div class="next_btn" @click="step_controll(1)" v-if="step!=7 && step!=8 && step!=15">
                        다음
                    </div>
            </div>
            <div class="pay_content_btn" v-if="step == 5">
                <div class="prev_btn" @click="step_controll_back()">
                    이전
                </div>
                <div class="next_btn" @click="do_pay_check()">
                    결제하기
                </div>
            </div>
        </div><!-- 오른쪽화면 -->
    </div>
    </div>
</div>
</template>

<script>
import vue from 'vue';
import * as config from '../../javascript/config';

// 결제모듈
import external from '@/assets/js/external.js';
import moment from 'vue-moment';

vue.use(moment);
export default {
    data: function () {
        return {
            step: 1,
            left_menu_list: [],
            now_date: '',
            end_date: '',
            select_groom_name: '',
            select_groom_id: '',
            select_groom_type_id: '',
            // 상품 목록 관련
            groom_prodcut_list: [],
            groom_goods_group_id: 0,
            groom_goods_id: 0,
            goods_group_name: "",
            selection_plan_code: "",
            groom_type_id: 0,
            type_name: "",
            goods_end_time: '',
            // 상품 시간 목록 관련
            groom_prodcut_time_list: [],
            use_hours: '',
            goods_time: '',
            groom_goods_name: '',
            card_amount: '',
            today_use_hours: '',
            use_end_datetime: '',
            use_start_datetime: '',
            product_division: '',
            // 내 상품 목록
            my_groom_prodcut_list: [],
            my_groom_purchase_history_id: '',
            my_groom_goods_id: '',
            my_goods_group_name: '',
            my_use_hours: '',
            my_use_total_hours: '',
            my_use_end_datetime: '',
            my_left_hours: '',
            my_type_name: '',
            my_groom_type_id: '',
            ////////            
            groom_limit_now_use : '',
            groom_limit_now_start_time : '',
            groom_limit_now_end_time : '',
            ////////

            //결제방법
            cash: true,
            card_installment: 0,
            cash_receipt: '0', // 0 == 개인(소득공제) 1 == 법인(지출증빙)
            cash_receipt_flag : false,
            //마일리지
            mileage_use_yn: '', //해당 매장에서 마일리지 사용여부
            mileage_chk: false,
            mileage_id: null,
            my_save_mileage: 0,
            milage_all: false,
            use_mileage: '',

            //할인쿠폰
            sale_use_yn: '', // 해당 매장에서 할인쿠폰 사용여부
            discount_coupon: false,
            discount_coupon_code: '',
            sale_id: 0,
            sale_rate: 0,
            discounted_price_card: '',
            discount_flag: false,

            last_price_card: '',

            // 금일 상품 시간 사용계획
            choice_use_time_list: [],
            choice_use_time: 0, // 값이 1일경우 1시간 0 일경우 defalut
            choice_use_time_left_list: [],
            choice_use_time_left: 0,

            // 참여인원권 / 1일시간권에 따른 내 상품 선택 view 여부
            goods_type_check: true,
            // 참여인원권/ 시간충전권별 분기 처리
            view_goods_type : '',
            // 참여인원권에 따른 방 정보
            person_groom_info : {},
            // 참여인원권에 따른 30분 단위 결제 정보
            person_groom_pay_info : {},
            person_groom_person_cnt : 0,
            person_groom_amount_time : 0,

            // 마일리지 사용 최소 단위
            use_min_unit: 0,
            // 마일리지 사용 최소 금액
            use_min_amount: 0,
            // 잔돈 방출 시 다음스텝으로 진행할 지 여부
            payment_return_kind: false,
            // 결제 진행 도중 취소버튼 안보이게
            btn_display_status: "inline-block",


            // 이용연장을 위한 사용하던 상품 데이터
            use_extention_groom_purchase_history_id: '',
            use_extention_use_end_datetime: '',
            use_extention_flag: false,
            use_extention_use_start_datetime: '',
            after_use_extention_use_end_datetime: '',
            use_hours_plan:0,

            // 결제 정보 관련
            app_number: 0,         // 승인번호
            payment_kind_name: '',  // 현금 : 종류, 카드 : 카드사명
            card_number: '',        // 카드번호(현금영수증번호)

            special_goods_flag : false, // 시간충전권 , 기간권 , 1일시간권 이 아닌 주간권,야간권,주간기간권,야간기간권을 체크하기위한 flag
            mileage_text: '',
            discount_text: '',
            price_text: '',
            refund: '',  // 환불규정

            usage_guide_useyn: 'n', //이용안내 사용여부
            usage_guide_data: null, //이용안내 데이터
        }
    },
    filters:{
        time_filter(value){
            var min = Math.floor(value%60);
            var hour = Math.floor(value/60);
            if(value != 0){
                if(min === 0){
                    return `${hour}시간`
                }else{
                    return `${hour}시간 ${min}분`
                }
            }else{
                return `${min}분`
            }
        },
         coupon_filter(value){
            var num = new Number(value);
            num = num.toFixed(0).replace(/\B(?=(\d{4})+(?!\d))/g, "-");
            return `${num}`
        }
    },
    methods: {
        step_finish() {
            var router = this.$router;
            router.push('/');
        },
        step_controll(val) {
            this.step += val;
            if (this.mileage_use_yn != 1 && this.sale_use_yn != 1 && this.step == 4) {
                this.step = 5;
            }

            if(this.mileage_use_yn != 1 && this.step == 3){
                this.step = 4;
            }

            if(this.sale_use_yn != 1 && this.step == 4){
                this.step = 5;
            }

            if (this.step == 1 &&
                this.groom_type_id == 0 ||
                this.groom_goods_group_id == 0) {
                const alert_param = {
                    code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                    message: `상품을 선택해 주세요.`,
                    router: '',
                };
                this.$store.commit('set_popup_type', alert_param);
                this.step -= 1;
                return;
            }
            //그룹룸 상품 시간호출
            if (this.step == 2) {
                if(this.goods_group_name.indexOf("시간") > -1){
                    this.view_goods_type = 'time';
                    this.groom_prodcut_time_list = [];
                    const type = config.REQ_GROOM_TIME_GET_LIST;
                    const data = {
                        'groom_type_id': this.groom_type_id,
                        'groom_goods_group_id': this.groom_goods_group_id
                    };
                    this.$store.dispatch(type.action_name, {
                        type: type,
                        data: data
                    }).then(response => {
                        for(let goods of response.data){
                            let hour = parseInt(goods.use_hours / 60);
                            let min = parseInt(goods.use_hours % 60);
                            if(min === 0){
                                goods.goods_time = hour+'시간';
                            }else{
                                goods.goods_time = hour+'시간 '+min+'분';
                            }
                            if(goods.groom_goods_name == '' || goods.groom_goods_name == undefined){ 
                                goods.groom_goods_name = goods.goods_time
                            }
                            this.groom_prodcut_time_list.push(goods);
                        }

                    }).catch(function (error) {
                        console.log('error=============>', error);
                    });
                }else{
                    this.left_menu_list[1].menu_name = '인원&시간';
                    this.view_goods_type = 'person';
                    const type = config.REQ_GROOM_PERSON_GET_LIST;
                    const data = {
                        'groom_type_id': this.groom_type_id,
                        'groom_goods_group_id': this.groom_goods_group_id,
                        'groom_id': this.select_groom_id,
                    };
                    this.$store.dispatch(type.action_name, {
                        type: type,
                        data: data
                    }).then(response => {
                        this.person_groom_info = response.data.count;
                        if(response.data.hours.length != 0){
                            for(var i = 0; i < response.data.hours.length; i++){
                                if(parseInt(response.data.hours[i].use_hours) == 30){
                                    this.person_groom_pay_info = response.data.hours[i];
                                }
                            }
                        }
                        if(response.data.count.length != 0){
                            this.person_groom_info = response.data.count[0];
                            this.person_groom_person_cnt = this.person_groom_info.min_user_count;
                        }

                    }).catch(function (error) {
                        console.log('error=============>', error);
                    });
                }

            }

            if (this.step == 3 && this.use_hours.length == 0 && this.view_goods_type == 'time') {
                const alert_param = {
                    code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                    message: `시간을 선택해 주세요.`,
                    router: '',
                };
                this.$store.commit('set_popup_type', alert_param);
                this.step -= 1;
                return;
            }

            if (this.step == 3 && this.use_hours.length == 0 && this.view_goods_type == 'person') {
                const alert_param = {
                    code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                    message: `시간과 인원을 선택해 주세요.`,
                    router: '',
                };
                this.$store.commit('set_popup_type', alert_param);
                this.step -= 1;
                return;
            }
            if(this.step == 3 && this.use_hours < 60 && this.view_goods_type == 'person'){
                    const alert_param = {
                    code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                    message: `시간은 최소 1시간 부터 사용가능합니다.`,
                    router: '',
                };
                this.$store.commit('set_popup_type', alert_param);
                this.step -= 1;
                return;
            }

            if (this.step == 3) {
              // 예약이 있는지 검사
              var exflag ='';
              if(this.use_extention_flag){
                  exflag = '1';
              }else{
                  exflag = '0';
              }
              const groom_reserv_check = config.REQ_GROOM_RESERV_CHECK
              this.$store.dispatch(groom_reserv_check.action_name, {
                  type: groom_reserv_check,
                  data: {
                    'use_hours' : this.use_hours,
                    'groom_id': this.select_groom_id,
                    'exflag':exflag
                  }
              }).then(response => {

                  let count = response.data[0].count
                  if(count > 0) {
                    const alert_param = {
                        code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                        message: `해당 시간에 예약내역이 있습니다.`,
                        router: '',
                        image_type : 'warning'
                    };
                    this.$store.commit('set_popup_type', alert_param)
                    this.step -= 1;
                  }
              }).catch(function (error) {
                  console.log('error=============>', error);
              });
                console.log(this.groom_limit_now_use)
                if (this.groom_limit_now_use == 'Y') {
                    let check_use_now = true;
                    let today = "";
                    
                    const processTimeCheck = (today) => {
                        console.log(this.use_hours)
                      let use_start_time = today == "" ? this.$moment() : this.$moment(today);
                      let use_end_time = this.$moment().add(this.use_hours, 'minutes');
                      let limit_now_start_time = this.$moment(this.$moment().format('YYYY-MM-DD')).add(this.groom_limit_now_start_time*1, 'hours');
                      // 250710 Number 추가
                      let limit_now_end_time = Number(this.groom_limit_now_start_time) < Number(this.groom_limit_now_end_time)
                      ? this.$moment(this.$moment().format('YYYY-MM-DD')).add(this.groom_limit_now_end_time*1, 'hours')
                      : this.$moment(this.$moment().format('YYYY-MM-DD')).add(this.groom_limit_now_end_time*1, 'hours').add(1, 'days');

                      if ((use_start_time.isBefore(limit_now_start_time) && use_end_time.isAfter(limit_now_start_time)) ||
                          (use_start_time.isSameOrAfter(limit_now_start_time) && use_start_time.isBefore(limit_now_end_time))) {
                        check_use_now = false;
                      }

                      // 그룹룸 사용 불가능한 시간일 경우 경고
                      if (!check_use_now) {
                          const alert_param = {
                              code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                              message: `그룹룸 즉시사용이 불가한 시간입니다.`,
                              router: '',
                              image_type: 'warning'
                          };
                          this.$store.commit('set_popup_type', alert_param);
                          this.step_controll_back();
                      }
                    };

                    if (exflag == 1) {
                        console.log('a'+today)
                        this.groomUseInfoCheck(this.select_groom_id).then(useEndDatetime => {
                            today = new Date(useEndDatetime + ":00");  
                            processTimeCheck(today); 
                        });
                    } else {
                        console.log('b'+today)
                        processTimeCheck(today); 
                    }
                }    
            }

            if (this.mileage_use_yn == 1 && this.step == 4) {
                if(this.mileage_chk){
                    if(this.use_mileage < this.use_min_amount){
                        const alert_param = {
                            code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                            message: `마일리지가 최소 금액보다 부족합니다.`,
                            router: '',
                        };
                        this.$store.commit('set_popup_type', alert_param);
                        this.step -= 1;
                        return;
                    }
                }
                if(this.use_mileage == this.card_amount.replace(/,/g,"")){
                    this.step = 5;
                }
            }

            if (this.milage_all && this.step == 4) {

                var card = 0;
                card = this.card_amount.replace(/,/g,"");

                card = card - Number(this.my_save_mileage) * 1;

                // this.last_price_card = card.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

                this.use_mileage = Number(this.my_save_mileage) * 1;
            }

            if (this.step == 4 && this.use_mileage > 0) {
                var card = 0;
                card = this.card_amount.replace(/,/g,"");

                let amount = card;

                if(amount < this.use_mileage){
                    const alert_param = {
                        code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                        message: `마일리지가 결제 금액보다 큽니다.`,
                        router: '',
                    };
                    this.$store.commit('set_popup_type', alert_param);
                    this.step -= 1;
                    this.use_mileage = 0;
                    return;
                }else{
                    card = card - this.use_mileage;
                    if(card == 0){
                        this.last_price_card = card.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        // this.step = 7;
                    }
                    // this.last_price_card = card.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                }
            } /* else if (this.step == 4 && this.use_mileage == 0 && !this.mileage_chk) {
                this.last_price_card = this.card_amount;
            } else if (this.step == 4 && this.use_mileage == 0 && this.mileage_chk) {
                this.last_price_card = this.card_amount;
            } */


            if (this.step == 5) {
                if(this.discount_coupon && !this.discount_flag){
                    const alert_param = {
                        code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                        message: `쿠폰코드를 입력해주세요. `,
                        router: '',
                    }
                    this.$store.commit('set_popup_type', alert_param);
                    this.step--;
                    return;
                }
                /* var price_card = this.last_price_card.replace(/,/g,"");
                //할인된 금액
                var discounted_price_card = Math.round(price_card * (this.sale_rate / 100));
                // 계산된 최종금액
                var new_price_card = price_card - discounted_price_card;
                //최종금액
                this.last_price_card = new_price_card.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                //할인된 최종금액
                this.discounted_price_card = discounted_price_card.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","); */
            }

            // if (this.mileage_use_yn != 1 && this.step == 4) {
            //     this.step = 5;
            // }

            // if (this.sale_use_yn != 1 && this.step == 5) {
            //     this.step = 6;
            // }

        },
        update_items_status() { //이전에 셋팅되어있던 item(좌석/사물함/그룹룸) 의 상태값을 체크후 상태 업데이트
            var status_chk = this.$store.getters['getItem_update_check'];
            if(status_chk.last_status == 'lock'){
                const condition_type = config.REQ_UPDATE_AVAILABLE_STATUS;
                const condition_data = {
                    'item_id': status_chk.item_id,
                    'item': status_chk.item
                };
                this.$store.dispatch(condition_type.action_name, {
                    type: condition_type,
                    data: condition_data
                }).then(response => {
                    if(response.result){
                    // 상태 체크를 위한 데이터 셋팅
                    this.$store.commit('set_Item_update_check', {
                        item_id: '',
                        item: '',
                        last_status:''
                    });
                    }
                }).catch(function (error) {
                    console.log('error=============>', error);
                });
            }
        },

        step_controll_back() {
            this.step -= 1;

            if (this.step == 0) {
                this.update_items_status();
                var router = this.$router;
                var last_url = this.$store.getters['get_last_url'];
                if (last_url == undefined ||
                    last_url == null ||
                    last_url == '' ||
                    last_url == 'undefined' ||
                    last_url == 'null' ||
                    last_url.length == 0) {
                    router.push('/');
                } else {
                    if(last_url == '/payment-group_room'){
                        router.push('/');
                    }else{
                        router.push(last_url); // 이동 위치를 입력
                    }
                }
            }
            if (this.mileage_use_yn != 1 && this.sale_use_yn != 1 && this.step == 4) {
                this.step = 2;
            }

            if(this.mileage_use_yn === 1 && this.step === 4) {
                this.step =3
            }

            if(this.sale_use_yn != 1 && this.step == 4){
                this.step = 3;
            }

            if(this.mileage_use_yn != 1 && this.step == 3){
                this.step = 2;
            }

            /* if(this.step == 5){
                this.discount_coupon = false;
                this.discount_flag = false;
                this.discounted_price_card = 0;
                var price_card = this.card_amount.replace(/,/g,"");
                this.last_price_card = price_card - this.use_mileage;
                this.last_price_card = this.last_price_card.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                this.discount_coupon_code = '';
            }
            if(this.step == 4){
                this.use_mileage = 0;
                this.mileage_chk = false;

                this.discount_coupon = false;
                this.discount_flag = false;
                this.discount_coupon_code = '';
                this.discounted_price_card = 0;
                this.last_price_card = this.card_amount;
            } */

            if(this.step == 3){
                if(this.use_mileage > 0){
                    this.mileage_chk = true;
                }else{
                    this.mileage_chk = false;
                }
            }

            if(this.step == 2){
                // this.use_mileage = 0;

                this.groom_goods_id = '';
                this.card_amount = '';
                this.last_price_card = '';
                this.use_hours = '';
                this.goods_time = '';
                this.groom_goods_name = '';
                this.product_division = '';
                this.use_mileage = '';
                this.discounted_price_card = '';
                this.mileage_text = '';
                this.goods_end_time = '';
                this.discount_text = '';
                this.price_text = '';
                this.discount_flag = false;
                this.mileage_chk = false;
                this.discount_coupon = false;
                this.discount_coupon_code = '';
                this.choice_use_time_list = [];
                for(var i = 0; i<this.groom_prodcut_time_list.length; i ++){
                    this.groom_prodcut_time_list[i].active_class= "";
                }
            }
            if(this.step == 1){
                this.groom_goods_id = '';
                this.card_amount = '';
                this.last_price_card = '';
                this.goods_end_time = '';
                this.price_text = '';
                this.use_hours = '';
                this.goods_time = '';
                this.groom_goods_name = ''; 
                this.product_division = '';
                for(var i = 0; i<this.groom_prodcut_time_list.length; i ++){
                    this.groom_prodcut_time_list[i].active_class= "";
                }

                this.groom_goods_group_id = '';
                this.goods_group_name = '';
                this.selection_plan_code = '';
                this.groom_type_id = '';
                this.type_name = '';
                for(var i = 0; i<this.groom_prodcut_list.length; i++){
                    this.groom_prodcut_list[i].active_class = "";
                }
            }


        },
        set_groom_product(item, index) {
            for(var i = 0; i<this.groom_prodcut_list.length; i++){
                this.groom_prodcut_list[i].active_class = "";
            }
            this.groom_prodcut_list[index].active_class = "pay-content-on";

            this.groom_goods_group_id = item.groom_goods_group_id;
            this.goods_group_name = item.goods_group_name;
            this.selection_plan_code = item.selection_plan_code;
            this.groom_type_id = item.groom_type_id;
            this.type_name = item.type_name;

        },
        set_groom_product_time(item, index) {
            for(var i = 0; i<this.groom_prodcut_time_list.length; i ++){
                this.groom_prodcut_time_list[i].active_class= "";
            }
            this.groom_prodcut_time_list[index].active_class = "pay-content-on";

            var event_item_chk = item.seat_event_goods_id;
            if (event_item_chk == null) {
                this.product_division = '일반';
            } else {
                this.product_division = '행사';
            }
            this.groom_goods_id = item.groom_goods_id;
            this.card_amount = item.card_amount;
            this.last_price_card = this.card_amount;
            this.use_hours = item.use_hours;
            this.goods_time = item.goods_time;
            this.groom_goods_name = item.groom_goods_name;
            this.choice_use_time_list = [];
            var end_day_count = item.end_day_count;
            if (this.goods_group_name.indexOf("시간충전권") > -1) {
                for (let i = 0; i < this.use_hours; i++) {
                    var time = i + 1;
                    this.choice_use_time_list.push(this.goods_time);
                }
            } else {
                this.today_use_hours = this.use_hours;
            }
            //상품의 유효기간 계산
            if (end_day_count == null) {

              if(this.use_extention_flag == true){
                let hour = new Date(this.use_extention_use_end_datetime).setMinutes(new Date(this.use_extention_use_end_datetime).getMinutes() + parseInt(item.use_hours));
                tDate = new Date(hour);

                // 날짜(일) 더하기
                tDate.setDate(tDate.getDate());
                tDate.setHours(tDate.getHours());
                var dd = tDate.getDate();
                var mm = tDate.getMonth() + 1; //January is 0!
                var yyyy = tDate.getFullYear();
                var currentTime = tDate.getHours() + "시 " + tDate.getMinutes() + "분 ";
                var h = tDate.getHours();
                var m = tDate.getMinutes();
                if (h < 10) {
                    h = '0' + h;
                }
                if (m < 10) {
                    m = '0' + m;
                }

                var currentTime_server = h + ':' + m + ':' + '00';
                if (dd < 10) {
                    dd = '0' + dd;
                }

                if (mm < 10) {
                    mm = '0' + mm;
                }
                this.goods_end_time = yyyy + '-' + mm + '-' + dd + ' ' + currentTime_server;
                //이용연장 시작시간을 알기위한 데이터 셋

              } else {

            //   var str_date = this.$store.getters['get_str_datetime'];
              var str_date = this.$moment().format("YYYY-MM-DD HH:mm:00");
              var tDate = new Date();
              // 날짜(일) 더하기
              tDate.setDate(tDate.getDate());
              tDate.setHours(tDate.getHours() + parseInt(item.goods_time));
              var dd = tDate.getDate();
              var mm = tDate.getMonth() + 1; //January is 0!
              var yyyy = tDate.getFullYear();
              var currentTime = tDate.getHours() + "시 " + tDate.getMinutes() + "분 ";
              var h = tDate.getHours();
              var m = tDate.getMinutes();
              if (h < 10) {
                  h = '0' + h;
              }
              if (m < 10) {
                  m = '0' + m;
              }

              var currentTime_server = h + ':' + m + ':' + '00';
              if (dd < 10) {
                  dd = '0' + dd;
              }

              if (mm < 10) {
                  mm = '0' + mm;
              }
              this.goods_end_time = yyyy + '-' + mm + '-' + dd + ' ' + currentTime_server;

              }
            } else {
                // var str_date = this.$store.getters['get_str_datetime'];
                var str_date = this.$moment().format("YYYY-MM-DD HH:mm:00");
                var tDate = new Date(str_date);
                // 날짜(일) 더하기
                tDate.setDate(tDate.getDate() + end_day_count);
                var dd = tDate.getDate();
                var mm = tDate.getMonth() + 1; //January is 0!
                var yyyy = tDate.getFullYear();
                var currentTime = tDate.getHours() + "시 " + tDate.getMinutes() + "분 ";
                var h = tDate.getHours();
                var m = tDate.getMinutes();
                if (h < 10) {
                    h = '0' + h;
                }
                if (m < 10) {
                    m = '0' + m;
                }

                var currentTime_server = h + ':' + m + ':' + '00';
                if (dd < 10) {
                    dd = '0' + dd;
                }

                if (mm < 10) {
                    mm = '0' + mm;
                }
                this.goods_end_time = yyyy + '-' + mm + '-' + dd + ' ' + currentTime_server;
            }

        },

        set_mileage(type) {
            if(type){
                this.mileage_chk = true;
                this.use_mileage = 0;
                this.mileage_text = '원';
            }else{
                if(!this.discount_flag){
                    this.last_price_card = this.card_amount;
                }else{
                    let calcul_payment = parseInt(this.last_price_card.replace(/,/g,"")) + this.use_mileage
                    this.last_price_card = calcul_payment.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                }
                this.use_mileage = '';
                this.mileage_text = '';
                this.mileage_chk = false;
            }
        },
        set_mileage_button(value) {
            if(this.use_min_amount > this.my_save_mileage){
                let use_min_amount_text = this.use_min_amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                const alert_param = {
                    code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                    message: `${use_min_amount_text} 마일리지 이상부터 사용 가능합니다.`,
                    router: '',
                    image_type : 'warning'
                };
                this.$store.commit('set_popup_type', alert_param);

                this.use_mileage = 0;
                return false;
            }
            
            if(typeof value === 'number'){
                this.use_mileage += parseInt(value);
            }else {
                this.use_mileage =  this.my_save_mileage;
            }

            if (this.use_mileage > this.my_save_mileage) {
                const alert_param = {
                    code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                    message: `사용하시려는 마일리지가 보유하고계신 마일리지보다 큽니다`,
                    router: '',
                    image_type : 'warning'
                };
                this.$store.commit('set_popup_type', alert_param);

                this.use_mileage -= value;
                return;
            }

            let amount = this.pay_type === 0 ? this.last_price_cash : this.last_price_card;

            var remain_pay = parseInt(parseInt(amount.replace(/,/g,""))/this.use_min_unit)*this.use_min_unit;
            if(value === 'all'){
                this.use_mileage = this.my_save_mileage;
                if(this.use_mileage == 0 || this.use_mileage == '0'){
                    const alert_param = {
                        code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                        message: `보유하고 계신 마일리지가 없습니다.`,
                        router: '',
                        image_type : 'warning'
                    };
                    this.$store.commit('set_popup_type', alert_param);
                }

                if(remain_pay > this.use_mileage){
                    remain_pay = parseInt(this.use_mileage/this.use_min_unit)*this.use_min_unit;
                    this.use_mileage = remain_pay;
                }


                if(this.use_min_amount > this.use_mileage || remain_pay > this.use_mileage){
                    const alert_param = {
                        code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                        message: `보유하고 계신 마일리지가 충분하지않습니다.`,
                        router: '',
                        image_type : 'warning'
                    };
                    this.$store.commit('set_popup_type', alert_param);
                    this.use_mileage = 0;
                }
            }else if(value === 'cancel'){
                this.use_mileage = 0;
                this.last_price_card = this.card_amount;
                return false;
            }

            if(amount.replace(/,/g,"") < this.use_mileage){
                this.use_mileage = remain_pay;
            }

            var card = 0; 
            card = this.card_amount.replace(/,/g,"");
            card = card - Number(this.use_mileage) * 1;
            this.last_price_card = card.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

        },
        milage_payment(mileage_data) {
            this.my_save_mileage = mileage_data;
        },
        set_discount_coupon(type) {
            // this.discount_coupon = !this.discount_coupon;
            if(type){
                this.discount_coupon = true;
                this.discounted_price_card = '0';
                this.discount_text = '원';
            }else{
                this.discount_coupon = false;
                this.discount_flag = false;
                if(this.discounted_price_card != 0){
                    this.last_price_card = (parseInt(this.last_price_card.replace(/,/g,"")) + parseInt(this.discounted_price_card.replace(/,/g,""))).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                }
                this.discounted_price_card = '';
                this.discount_text = '';
                this.discount_coupon_code = '';
            }
        },
        coupon_check() {
            //할인쿠폰 적용 여부
            if (this.discount_coupon) {

                const type = config.REQ_COUPON_GET;
                const data = {
                    'sale_code': this.discount_coupon_code.toString().replace(/\B(?=(\d{4})+(?!\d))/g, "-")
                };
                this.$store.dispatch(type.action_name, {
                    type: type,
                    data: data
                }).then(response => {
                    var result;
                    result = response.result;
                    if (result && !this.discount_flag && response.data.message) {
                        this.sale_id = response.data.data[0].sale_id;
                        this.sale_rate = response.data.data[0].sale_rate;

                        var price_card = this.last_price_card.replace(/,/g,"");
                        //할인된 금액
                        var discounted_price_card = Math.round(price_card * (this.sale_rate / 100));
                        // 계산된 최종금액
                        var new_price_card = price_card - discounted_price_card;
                        //최종금액
                        this.last_price_card = new_price_card.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        //할인된 최종금액
                        this.discounted_price_card = discounted_price_card.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

                        // this.step++;
                        this.discount_flag = true;
                        const alert_param = {
                            code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                            message: `할인쿠폰이 적용되었습니다. `,
                            router: '',
                        }
                        this.$store.commit('set_popup_type', alert_param);
                    } else if (!result) {
                        const alert_param = {
                            code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                            message: `쿠폰코드를 다시한번 확인해주세요. `,
                            router: '',
                        }
                        this.$store.commit('set_popup_type', alert_param);
                    } else if (result && this.discount_flag) {
                        const alert_param = {
                            code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                            message: `할인쿠폰이 이미 적용되어있습니다. `,
                            router: '',
                        }
                        this.$store.commit('set_popup_type', alert_param);
                    } else {
                        const alert_param = {
                            code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                            message: `쿠폰코드를 다시한번 확인해주세요. `,
                            router: '',
                        }
                        this.$store.commit('set_popup_type', alert_param);
                    }
                }).catch(function (error) {
                    console.log('error=============>', error);
                });
            }
        },
        choice_myproduct(item) {
            this.step = 15;
            this.my_groom_purchase_history_id = item.groom_purchase_history_id;
            this.my_groom_goods_id = item.groom_goods_id;
            this.my_goods_group_name = item.goods_group_name;
            this.my_use_hours = item.use_hours;
            this.my_use_total_hours = item.use_total_hours;
            this.my_use_end_datetime = item.use_end_datetime;
            this.my_left_hours = item.left_hours;
            this.my_type_name = item.type_name;
            this.my_groom_type_id = item.groom_type_id;

            var list_length = this.my_left_hours;
            if (this.my_left_hours > 10) {
                list_length = 10;
            }
            this.choice_use_time_left_list = [];
            for (let i = 0; i < list_length; i++) {
                var time = i + 1;
                this.choice_use_time_left_list.push(time + '시간');
            }

        },
        set_groom_user() {

            if (this.choice_use_time_left > this.my_left_hours) {
                const alert_param = {
                    code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                    message: `남아있는 시간보다 더 사용하실수 없습니다. `,
                    router: '/',
                };
                this.$store.commit('set_popup_type', alert_param);
                return;
            }

            if (this.choice_use_time_left == 0) {
                const alert_param = {
                    code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                    message: `사용시간을 선택해주세요. `,
                    router: '/',
                };
                this.$store.commit('set_popup_type', alert_param);
                return;
            }
            // var str_date = this.$store.getters['get_str_datetime'];
            var str_date = this.$moment().format("YYYY-MM-DD HH:mm:00");

            var tDate = new Date(str_date);
            // 날짜(일) 더하기
            tDate.setHours(tDate.getHours() + this.choice_use_time_left);
            var dd = tDate.getDate();
            var mm = tDate.getMonth() + 1; //January is 0!
            var yyyy = tDate.getFullYear();
            var currentTime = tDate.getHours() + "시 " + tDate.getMinutes() + "분 ";
            var h = tDate.getHours();
            var m = tDate.getMinutes();
            if (h < 10) {
                h = '0' + h;
            }
            if (m < 10) {
                m = '0' + m;
            }

            var currentTime_server = h + ':' + m + ':' + '00';
            if (dd < 10) {
                dd = '0' + dd;
            }

            if (mm < 10) {
                mm = '0' + mm;
            }
            this.use_end_datetime = yyyy + '-' + mm + '-' + dd + ' ' + currentTime_server;
            this.use_start_datetime = str_date;

            //그룹룸배정
            const type = config.REQ_GROOM_USE_INSERT;
            const data = {
                'data': {
                    'groom_id': this.select_groom_id,
                    'groom_purchase_history_id': this.my_groom_purchase_history_id,
                    'use_hours': this.choice_use_time_left,
                    'use_count': null,
                    'use_end_datetime': this.use_end_datetime,

                }
            };
            this.$store.dispatch(type.action_name, {
                type: type,
                data: data
            }).then(response => {
                if (response.result) {
                    const alert_param = {
                        code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                        message: `${this.select_groom_name}번 그룹룸에 배정되었습니다. `,
                        router: '/',
                    };
                    this.$store.commit('set_popup_type', alert_param);
                    var router = this.$router;
                    router.push('/');

                }
            }).catch(function (error) {
                console.log('error=============>', error);
            });
        },
        do_pay_check(){
            let self = this;
            if(this.last_price_card == 0){
                let result = {
                    "cno" : null,
                    "pay_type" : null
                };
                self.do_pay(result);
            }else{
                // 결제모듈
                var pay_info = {
                    mall_id : this.$store.getters['getStoreInfo'].store_imp_code, // 가맹점 ID
                    // mall_id : 'T5102001', // 가맹점 ID
                    mall_nm : this.$store.getters['getStoreInfo'].store_name, // 가맹점명
                    product_nm : this.goods_group_name + '_' + this.type_name, // 상품이름
                    product_amt : this.last_price_card != 0 ? this.last_price_card.replace(/,/g,"") : this.last_price_card, // 결제금액
                    product_expr : "", // 서비스기간 : YYYYMMDD, 예) 20201231
                    user_id : this.$store.getters['getUser'].user_hp, // 가맹점 고객 ID(가맹점 고객 번호)
                    user_no : this.$store.getters['getUser'].user_id, // 가맹점 고객 일련번호
                    user_nm : this.$store.getters['getUser'].name, // 가맹점 고객명
                    user_phone : this.$store.getters['getUser'].user_hp, // 가맹점 고객 번호
                    sp_user_define1 : this.$store.getters['getStoreInfo'].store_id, // 가맹점 아이디
                    sp_user_define2 : this.$store.getters['getStoreInfo'].store_name // 가맹점 이름
                }
                var callbackTemplate = function(command, result){
                    if(result.res_cd == '0000'){
                        self.do_pay(result);
                    }else{
                        const alert_param = {
                            code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                            message: result.res_msg,
                            router: '',
                        }
                        this.$store.commit('set_popup_type', alert_param);
                    }
                };
                mobileBriddgeConn(pay_info, callbackTemplate);
            }

        },
        do_pay(result) {
            // 상품종류 code 좌석/사물함/그룹룸
            var self = this;

            // var str_date = this.$store.getters['get_str_datetime'];
            var str_date = this.$moment().format("YYYY-MM-DD HH:mm:00");
            let status_code;
            let continue_yn;
            this.use_start_datetime = str_date;

            //이용연장 구매라면

            if (this.use_extention_flag) {

                let hour = new Date(this.use_extention_use_end_datetime).setMinutes(new Date(this.use_extention_use_end_datetime).getMinutes() + parseInt(this.today_use_hours));
                tDate = new Date(hour);

                status_code = 'GROOM_AVAILABLE'
                continue_yn = 1

                tDate.setDate(tDate.getDate());
                var dd = tDate.getDate();
                var mm = tDate.getMonth() + 1; //January is 0!
                var yyyy = tDate.getFullYear();
                var h = tDate.getHours();
                var m = tDate.getMinutes();

                if (h < 10) {
                    h = '0' + h;
                }
                if (m < 10) {
                    m = '0' + m;
                }
                var currentTime = h + ":" + m + ':00';

                if (dd < 10) {
                    dd = '0' + dd;
                }

                if (mm < 10) {
                    mm = '0' + mm;
                }

                this.after_use_extention_use_end_datetime = tDate = yyyy + '-' + mm + '-' + dd + ' ' + currentTime;
                // this.end_date_for_server = this.after_use_extention_use_end_datetime;
                // this.now_date = this.use_extention_use_end_datetime;
                //this.end_date_for_server = this.after_use_extention_use_end_datetime;
                //this.now_date = null;
                // this.choice_use_time = this.choice_use_left_time;
                this.use_end_datetime = yyyy + '-' + mm + '-' + dd + ' ' + currentTime;
                // this.use_start_datetime = str_date;
            } else {

              var tDate = new Date();
              status_code = 'USING'
              continue_yn = 0
              // 날짜(일) 더하기
              var add_hour = Math.floor(this.today_use_hours/60);
              var add_minitue = Math.floor(this.today_use_hours%30);
              if(add_hour != 0){
                  tDate.setHours(tDate.getHours() + add_hour);
              }
              if(add_minitue != 0){
                  tDate.setMinutes(tDate.getMinutes() + add_hour);
              }
              var dd = tDate.getDate();
              var mm = tDate.getMonth() + 1; //January is 0!
              var yyyy = tDate.getFullYear();
              var currentTime = tDate.getHours() + "시 " + tDate.getMinutes() + "분 ";
              var h = tDate.getHours();
              var m = tDate.getMinutes();
              if (h < 10) {
                  h = '0' + h;
              }
              if (m < 10) {
                  m = '0' + m;
              }

              var currentTime_server = h + ':' + m + ':' + '00';
              if (dd < 10) {
                  dd = '0' + dd;
              }

              if (mm < 10) {
                  mm = '0' + mm;
              }

              this.use_end_datetime = yyyy + '-' + mm + '-' + dd + ' ' + currentTime_server;

            }





            var get_item_code = this.$store.getters['get_tab_code_list'];
            for (let i = 0; i < get_item_code.length; i++) {
                if (get_item_code[i].code_name == "그룹룸") {
                    get_item_code = get_item_code[i].code;
                    break;
                }
            }

            var left_time;

            var payment_kind_code;
            var payment_amount;
            var goods_amount;
            var sale_amount;
            var card_div;
            payment_kind_code = 'CARD';
            payment_amount = this.last_price_card == 0 ? this.last_price_card : this.last_price_card.replace(/,/g,"");
            goods_amount = this.card_amount;
            sale_amount = this.discounted_price_card;
            card_div = this.card_installment // 1 = 일시불 2 = 2개월
            goods_amount = goods_amount.replace(/,/g,"");

            // 마일리지 사용여부 체크
            var mileage = {};

            if (this.mileage_chk) {
                mileage = {
                    'total_amount': Number(this.my_save_mileage) - this.use_mileage, // '총_금액', => 총금액 - 마일리지 사용 금액
                    'change_amount': this.use_mileage // '변동_금액',  => 마일리지 사용 금액
                }
            }

            //할인쿠폰 사용여부 체크
            var sale = {};

            if (this.discount_coupon && this.discount_flag) {
                sale = {
                    'sale_id': this.sale_id
                }
                sale_amount = sale_amount.replace(/,/g,"");
            } else {
                sale_amount = '';
                this.sale_id = null;
            }

            if(!this.cash_receipt_flag){
                this.cash_receipt = '0';
            }

            let use_status_code = 'USING';
            var groom_extention_yn;
            if(this.use_extention_flag){
                groom_extention_yn = true;
            }else{
                groom_extention_yn = false;
            }

            const type = config.REQ_PAYMENT_INSERT;
            const data = {
                'data': {
                    'mileage_yn': self.mileage_chk, //'마일리지_사용_여부', Y or N
                    'sale_yn': self.discount_coupon, // 할인쿠폰 사용여부
                    'purchase_type': get_item_code, //'구매_타입', // seat || locker || groom
                    'dirUseCheck': true, //false 상품구매 true 즉시사용
                    'mobile_yn': true, // 모바일 여부
                    'groom_extention_yn':groom_extention_yn, //연장여부 - 예약테이블에 데이터를 넣기위한 flag

                    'payment': {
                        'sale_id': self.sale_id, //'할인권_ID'
                        'payment_kind_code': payment_kind_code, // 현금인지 카드인지
                        'payment_status_code': 'COMPLETE',
                        'goods_type_code': get_item_code, // TAB 에 달려있는 데이터를 넣어줘야함
                        'approval_number': self.app_number,
                        'payment_amount': payment_amount * 1,
                        'goods_amount': goods_amount * 1,
                        'sale_amount': sale_amount * 1,
                        'card_div': card_div,
                        'payment_kind_name': self.payment_kind_name,    // 카드사명
                        'card_number': self.card_number,                // 카드번호
                        'goods_name': self.goods_group_name + '_' + self.type_name,
                        'seat_name': this.select_groom_name,
                        'groom_goods_name': self.groom_goods_name + '_' + self.type_name,
                        'cash_receipt':self.cash_receipt, // 현금 영수증
                        'cno': result.cno, 
                        'pay_type': result.pay_type 
                    },

                    // 마일리지_사용_여부가 'Y'일때
                    mileage: mileage,

                    // 할인쿠폰_적용_여부가 'Y'일때
                    'sale': sale,

                    'purchase': {
                        // groom_purchase인 경우
                        'groom_exten_start_time': self.use_extention_use_start_datetime,
                        'groom_exten_end_time': self.use_extention_use_end_datetime,
                        'groom_id': self.select_groom_id,
                        'groom_goods_id': self.groom_goods_id,
                        'use_start_datetime': self.use_start_datetime,
                        'use_end_datetime': self.use_end_datetime,
                        'use_hours': self.today_use_hours,
                        'use_count': self.person_groom_person_cnt, // 이용자수
                        'use_total_hours': 0,
                        'left_hours': self.use_hours,
                        'countHour': self.goods_end_time, // 만료일수
                        'groom_status_code' : status_code,
                        'use_status_code': use_status_code,
                        'continue_yn' : continue_yn,
                        'groom_purchase_history_id' : self.use_extention_groom_purchase_history_id, // 연장 등록시 이전에 groom_use 테이블에 박혀있는 history id
                        'startDate_for_receipt':self.now_date2
                    } 
                }
            }; // store_id는 공통으로 추가하니까 생략. 예) {user_id: 123}
        
            self.$store.dispatch(type.action_name, {
                type: type,
                data: data
            }).then(response => {
                if (response.result) {
                    // self.$store.commit('set_Item_update_check', {
                    //             item_id: self.select_groom_id,
                    //             item:'groom',
                    //             last_status:'using'
                    // });
                    // self.step_controll(1);
                    //if(response.message == 'occupy'){
                   	if(response.message){ // 위의 주석처리의 조건으로 모바일에서 구매시 다른 고객이 먼저 자리를 점유했다는 오류발생하여 조건변경함 2021.01.14
                        self.step_controll(1);
                        self.$store.commit('set_Item_update_check', {
                            item_id: self.select_groom_id,
                            item: 'groom',
                            last_status: 'using'
                        });
                    }else{
                        const alert_param = {
                            code: self.$store.getters['get_popup_code'].POPUP_ALERT,
                            message: `<span>다른 고객이 자리를 먼저 점유해 상품으로 전환되었습니다.</span><br><span>마이페이지에서 확인하세요.</span>`,
                            router: '',
                        }
                        self.$store.commit('set_popup_type', alert_param);
                        this.$router.push('/mypage');
                        return;
                    }
                }

            }).catch(function (error) {
                console.log('error=============>', error);
            });

        },
        // 쿠폰입력
        coupoun_input(type_num){
            if(type_num == 'del'){
                if(this.discount_coupon_code.length != 0){
                    this.discount_coupon_code = this.discount_coupon_code.substr(0, this.discount_coupon_code.length-1);
                }
            }else{
                if(this.discount_coupon_code.length <= 11){
                    this.discount_coupon_code = this.discount_coupon_code + type_num;
                }else{
                    return false;
                }
            }
        },
        get_left_menu(){
            this.left_menu_list =  [];
            this.left_menu_list.push({active_class: "process_on", img_src:  require("../../assets/image/process02_on.png"), menu_name : "상품선택" , nomal_step : 2});
            this.left_menu_list.push({active_class: "", img_src:  require("../../assets/image/process03_on.png"), menu_name : "시간선택" , nomal_step : 3});
            if(this.mileage_use_yn != 0){
                this.left_menu_list.push({active_class: "", img_src:  require("../../assets/image/process04_on.png"), menu_name : "마일리지" , nomal_step : 4});
            }
            if(this.sale_use_yn != 0){
                this.left_menu_list.push({active_class: "", img_src:  require("../../assets/image/process05_on.png"), menu_name : "할인쿠폰" , nomal_step : 5});
            }
            this.left_menu_list.push({active_class: "", img_src:  require("../../assets/image/process06_on.png"), menu_name : "결제" , nomal_step : 6});
            this.left_menu_list.push({active_class: "", img_src:  require("../../assets/image/process07_on.png"), menu_name : "완료" , nomal_step : 7});
        },
        use_my_alarm(){
            console.log('a')
            this.$store.commit('set_groom_move_step', 1);
            const alert_param = {
                code: this.$store.getters['get_popup_code'].POPUP_GROOM_USE_PRODUCT_LIST,
            }
            this.$store.commit('set_popup_type', alert_param);
        },
        money_filter(value){
            var num = new Number(value);
            num = num.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            return `${num}`
        },
        definePaymentForPseron(){
            var pay_cnt = Math.floor(this.person_groom_amount_time/30);
            var card_won = parseInt(this.person_groom_pay_info.card_amount.replace(/,/g,""));
            this.card_amount = this.money_filter(pay_cnt*card_won*this.person_groom_person_cnt);

            this.product_division = '일반';
            this.groom_goods_id = this.person_groom_pay_info.groom_goods_id;
            this.use_hours = this.person_groom_amount_time;
            this.goods_time = this.person_groom_amount_time;
            let hour = parseInt(this.person_groom_amount_time / 60);
            let min = parseInt(this.person_groom_amount_time % 60);
            if(min === 0){
                this.goods_time = hour+'시간';
            }else{
                this.goods_time = hour+'시간 '+min+'분';
            }
            this.choice_use_time_list = [];

            if (this.goods_group_name.indexOf("시간충전권") > -1) {
                for (let i = 0; i < this.use_hours; i++) {
                    var time = i + 1;
                    this.choice_use_time_list.push(this.goods_time);
                }
            } else {
                this.today_use_hours = this.use_hours;
            }
            // //상품의 유효기간 계산
            // var str_date = this.$store.getters['get_str_datetime'];
            var str_date = this.$moment().format("YYYY-MM-DD HH:mm:00");
            var tDate = new Date(str_date);
            // 날짜(일) 더하기
            var add_hour = Math.floor(this.today_use_hours/60);
            var add_minute = Math.floor(this.today_use_hours%60);
            if(add_hour != 0){
                tDate.setHours(tDate.getHours() + add_hour);
            }
            if(add_minute != 0){
                tDate.setMinutes(tDate.getMinutes() + add_minute);
            }

            var dd = tDate.getDate();
            var mm = tDate.getMonth() + 1; //January is 0!
            var yyyy = tDate.getFullYear();
            var currentTime = tDate.getHours() + "시 " + tDate.getMinutes() + "분 ";
            var h = tDate.getHours();
            var m = tDate.getMinutes();
            if (h < 10) {
                h = '0' + h;
            }
            if (m < 10) {
                m = '0' + m;
            }
            var currentTime_server = h + ':' + m + ':' + '00';
            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            this.goods_end_time = yyyy + '-' + mm + '-' + dd + ' ' + currentTime_server;

            this.last_price_card = this.card_amount;

        },
        // 인원수 추가
        clickPerson(type){
            var person_groom_info = this.person_groom_info;
            if(person_groom_info != null){
                var max_count = parseInt(person_groom_info.max_user_count);
                var min_count = parseInt(person_groom_info.min_user_count);
                if(type == 'plus'){
                    if(parseInt(this.person_groom_person_cnt) < max_count){
                        this.person_groom_person_cnt += 1;
                    }
                }else{
                    if(parseInt(this.person_groom_person_cnt) > min_count){
                        this.person_groom_person_cnt -= 1;
                    }
                }
                if(this.person_groom_amount_time != 0){
                    this.definePaymentForPseron();
                }
            }else{
            }

        },
        // 시간추가
        clickTime(time){
            if(this.person_groom_pay_info != null){
                var person_cnt = parseInt(this.person_groom_person_cnt);
                if(person_cnt == 0){
                    const alert_param = {
                        code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                        message: ` 참여인원을 설정 후 이용해주세요`,
                        router: '/',
                    };
                    this.$store.commit('set_popup_type', alert_param);
                }else{
                    if(time == '0'){
                        this.use_hours = '';
                        this.person_groom_amount_time = 0;
                        this.card_amount = 0;
                    }else{
                        this.person_groom_amount_time += parseInt(time);
                        this.definePaymentForPseron();
                    }
                }
            }else{
            }

        },
        groomOptionCheck(){
            const reserv_type = config.REQ_STORE_OPTION;
            this.$store.dispatch(reserv_type.action_name, {
                type: reserv_type,
                data: {'store_id':this.$store.getters['getStoreId']}
            }).then(response => {
                console.log(response.data)
                 this.groom_limit_now_use = response.data.groom_limit_now_use;
                 this.groom_limit_now_start_time = response.data.groom_limit_now_start_time;
                 this.groom_limit_now_end_time = response.data.groom_limit_now_end_time; 
                  
            }).catch(function (error) {
                console.log('error=============>', error);
            });
        },        
        async groomUseInfoCheck(val){
        // 그룹룸 로직 상품 추가
            const type = config.REQ_GROOM_USE_SELECT;
            var user_data = this.$store.getters['getUser'];
            var roomreturn = '';
            const data = {
                'user_id': user_data.user_id,
                'groom_id': val
            };

            return this.$store.dispatch(type.action_name, {
                type: type,
                data: data
            }).then(response => {
                console.log(response.data[0].use_end_datetime)
                //this.groom_info = response.data;
                return response.data[0].use_end_datetime; 
                //roomreturn = response.data[0].use_end_datetime;
            }).catch(function (error) {
                console.log('error=============>', error);
            });
            
        },
        //250514 이용안내 팝업용으로 추가
        async get_usage_guide(){
            const type = config.REQ_GET_USAGE_GUIDE;
            const data = {
                store_id: this.$store.getters['getStoreInfo'].store_id,
            };
            try {
                const response = await this.$store.dispatch(type.action_name, {
                    type: type,
                    data: data
                });
                if(response.use_yn == 'y'){
                    return response;
                }
                return null;
            } catch (error) {
                console.log('error=============>', error);
                return null;  //실패시 대비
            }
        },
        async open_guide(){
            let send_data = null;
            const result = await this.get_usage_guide();
            if (result) {
                send_data = { 
                            seat_guide: result.seat_guide, 
                            locker_guide: result.locker_guide, 
                            groom_guide: result.groom_guide
                        }
                const alert_param = {
                    code: this.$store.getters['get_popup_code'].POPUP_USE_GUIDE,
                    data: send_data
                }
                this.$store.commit('set_popup_type', alert_param);
            }
        }

    },
    mounted() {
        this.$nextTick(function () {
            this.refund = this.$store.getters['get_refund_text'];
            // main 쪽 좌석 라커 그룹룸 보여주게할 값 셋팅
            this.$store.commit('change_main_tab_chk', {
                value: 2  // =>0좌석 1 사물함 2 그룹룸
            });

            var yndata = this.$store.getters['getUseyn'];
            if(typeof yndata == "undefined"){
                this.sale_use_yn = 0;
                this.mileage_use_yn = 0;
            }else{
                this.sale_use_yn = yndata.sale_apply_yn;
                this.mileage_use_yn = yndata.groom_use_yn;
                this.use_min_unit = yndata.use_min_unit;
                this.use_min_amount = yndata.use_min_amount;
            }
            this.get_left_menu();            
            this.groomOptionCheck();
            var groom_data = this.$store.getters['get_select_groom'];
            this.select_groom_id = groom_data[0].groom_id;
            this.select_groom_name = groom_data[0].groom_name;
            // this.groom_type_id = groom_data[0].groom_type_id;
            // this.groom_goods_group_id = groom_data[0].groom_goods_group_id;
            // this.goods_group_name = groom_data[0].goods_group_name;
            // this.selection_plan_code = groom_data[0].selection_plan_code;
            // this.type_name = groom_data[0].type_name;

            this.groom_prodcut_time_list = [];
            const type1 = config.REQ_GROOM_TIME_GET_LIST;
            const data1 = {
                'groom_type_id': this.groom_type_id,
                'groom_goods_group_id': this.groom_goods_group_id
            };

            this.$store.dispatch(type1.action_name, {
                type: type1,
                data: data1
            }).then(response => {
                for(let goods of response.data){
                    let hour = parseInt(goods.use_hours / 60);
                    let min = parseInt(goods.use_hours % 60);
                    if(min === 0){
                        goods.goods_time = hour+'시간';
                    }else{
                        goods.goods_time = hour+'시간 '+min+'분';
                    }
                    if(goods.groom_goods_name == '' || goods.groom_goods_name == undefined){ 
                        goods.groom_goods_name = goods.goods_time
                    } 
                    this.groom_prodcut_time_list.push(goods);
                }
            }).catch(function (error) {
                console.log('error=============>', error);
            });

            // 그룹룸 상품 호출 req
            var user_data = this.$store.getters['getUser'];
            const my_info_data = {
                'user_id': user_data.user_id
            };

            // 내 그룹룸 상품목록 req
            const myproduct_list_type = config.REQ_MYPAGE_GROOM_GOODS_GET_LIST;
            const type = config.REQ_GROOM_GOODS_SEL_GET_LIST;
            const use_check = config.REQ_GROOM_USE_CHECK;
            const data = {};
            data.groom_id = this.select_groom_id;
            Promise.all(
                [
                    this.$store.dispatch(myproduct_list_type.action_name, {
                        type: myproduct_list_type,
                        data: my_info_data
                    }),
                    this.$store.dispatch(type.action_name, {
                        type: type,
                        data: data
                    }),
                    this.$store.dispatch(use_check.action_name, {
                        type: use_check,
                        data: data
                    })
                ]
            ).then(responseList => {
                // 응답 - 요청 순서별 응답 array
                this.my_groom_prodcut_list = responseList[0].data;
                var temp_product_list = responseList[1].data;
                for(var i = 0; i< temp_product_list.length; i++){
                    var groom_product = temp_product_list[i];
                    if(groom_product.selection_plan_code === 'GROOM_TIME_PLAN'){
                        this.groom_prodcut_list.push(groom_product);
                    }
                    if(groom_product.selection_plan_code === 'GROOM_PERSON_PLAN'){
                        this.groom_prodcut_list.push(groom_product);
                         // this.goods_type_check = false;
                    }
                }

                for (let i = 0; i < responseList[2].data.length; i++) {

                    if (this.select_groom_id === responseList[2].data[i].groom_id) {
                        this.use_extention_groom_purchase_history_id = responseList[2].data[i].groom_purchase_history_id;
                        this.use_extention_use_end_datetime = responseList[2].data[i].use_end_datetime;
                        this.use_extention_use_start_datetime = responseList[2].data[i].use_start_datetime;

                        this.use_extention_flag = true;
                        this.use_hours_plan = responseList[2].data[i].use_hours_plan;
                        // alert('지금 선택된 좌석 : '+this.seat_id +'   '+'지금내가 사용하고 있는 상품이 달려있는 좌석 :'+response.data[i].seat_id);
                    }
                }
                this.$store.commit('setExtention_flag', {
                    value : this.use_extention_flag
                });

            }).catch(function (error) {
                console.log('error=============>', error);
            });

            // this.sit_num = localStorage.getItem('sit_number');
            var today = new Date();
            var dd = today.getDate();
            var mm = today.getMonth() + 1; //January is 0!
            var yyyy = today.getFullYear();
            var currentTime = today.getHours() + "시 " + today.getMinutes() + "분 ";

            var h = today.getHours();
            var m = today.getMinutes();

            if (h < 10) {
                h = '0' + h;
            }
            if (m < 10) {
                m = '0' + m;
            }

            var currentTime_server = h + ":" + m;

            if (dd < 10) {
                dd = '0' + dd;
            }

            if (mm < 10) {
                mm = '0' + mm;
            }

            this.now_date = today = yyyy + '-' + mm + '-' + dd + ' ' + currentTime;
            this.now_date2 = today = yyyy + '-' + mm + '-' + dd + ' ' + currentTime_server + ':00';
            const condition_type = config.REQ_UPDATE_LOCK_STATUS;
            const condition_data = {
                'item_id': this.select_groom_id,
                'item': 'groom'
            };
            this.$store.dispatch(condition_type.action_name, {
                type: condition_type,
                data: condition_data
            }).then(response => {
                if(response.result){
                    this.$store.commit('set_Item_update_check', {
                                item_id: this.select_groom_id,
                                item:'groom',
                                last_status:'lock'
                    });
                }
            }).catch(function (error) {
                console.log('error=============>', error);
            });
            
            // 250514 이용안내 추가 
            this.get_usage_guide()
            .then(result => {
                if (result && result.use_yn === 'y') {
                    this.usage_guide_useyn = 'y';
                    this.usage_guide_data = result;
                }
            })
            .catch(error => {
                console.log('error=============>', error);
            });

        });


    },
    computed: {
        get_groom_move_step() {
            return this.$store.getters.get_groom_move_step;
        }
    },
    beforeDestroy(){
        this.$store.commit('set_payment_Start', false);
    },
    watch:{
        step(){
            for(var i = 0; i < this.left_menu_list.length; i++){
                this.left_menu_list[i].active_class = '';
                if(this.left_menu_list[i].nomal_step == (this.step+1)){
                    this.left_menu_list[i].img_src = require("../../assets/image/process0"+(this.left_menu_list[i].nomal_step)+"_on.png");
                    this.left_menu_list[i].active_class = 'process_on';
                    for (var n=0; n<i; n++) {
                        this.left_menu_list[n].active_class = 'process_finish';
                    }
                }else{
                    this.left_menu_list[i].img_src = require("../../assets/image/left_ico_0"+(this.left_menu_list[i].nomal_step)+".png");
                }
            }
        },
        get_groom_move_step() {
            this.step = this.$store.getters.get_groom_move_step;
        }
    }
}
</script>

<style>
</style><style>
.vdp-datepicker .vdp-datepicker__calendar {
    position: relative;
    /* // width: 355%; */
    height: 100%;

}

.good-body .info_area_2 {
    position: absolute;
    background: #fff;
    top: 10%;
    left: 40%;
    width: 632px;
    height: 650px;
    border: 3px solid #b9b9b9;
    border-radius: 2.5px;
    padding: 80px 60px 55px;
    font-size: 35px;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Payment_group_room.vue